import React, { useRef, useState } from "react";
import { CopyIcon, PriceChartIcon } from "../../../IconTheme";

const StakingLeaderboard = () => {
	return (
		<div className="chart-card pb-0">
			<div className="price-chart-header d-flex flex-wrap align-items-center">
				<PriceChartIcon />
				<h5 className="m-0 mt-1 ps-2">Stake Leaderboard</h5>
			</div>
			<div className="staking-leaderboard">
				<ul className="staking-leaderboard-list">
					{["", "", "", "", "", "", ""].map((item, i) => (
						<ListItem index={i} key={i} />
					))}
				</ul>
			</div>
		</div>
	);
};

export const ListItem = ({ index }) => {
	const [value, setValue] = useState("0x8487869....9391");
	const [copy, setCopy] = useState(false);

	const ref = useRef();
	const handleClick = () => {
		navigator.clipboard.writeText(value);
		setInterval(() => {
			setCopy(false);
		}, 300);
	};
	return (
		<li>
			<div className="left">
				<span className="serial">
					<span>{index + 1}</span>
				</span>
				<span
					style={{ transform: "translateY(2px)" }}
					className="d-inline-flex"
				>
					<span className="me-1">Stake Amount:</span>
					<strong>1000 ANT</strong>
				</span>
			</div>
			<div className="right">
				<input type="text" ref={ref} value={value} />
				<span
					type="button"
					onClick={() => {
						handleClick();
						setCopy(!copy);
					}}
				>
					{!copy ? <CopyIcon /> : "Copied"}
				</span>
			</div>
		</li>
	);
};

export default StakingLeaderboard;
